"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _cssConstants = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/cssConstants.js"));

var _config = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/config.js"));

var _ErvNestedTiles = _interopRequireDefault(require("./ErvNestedTiles.scss"));

var _PreconditionChecker = require("../../../utils/PreconditionChecker");

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _KESI2Helper = _interopRequireDefault(require("../../../KESI2/KESI2Helper"));

var _Check = _interopRequireDefault(require("@material-ui/icons/Check"));

var _KESI2BasicComponent = _interopRequireDefault(require("../../../KESI2/KESI2BasicComponent"));

var _DrupalNestedTileSizes = require("./DrupalNestedTileSizes");

var _Constants = require("../../constants/Constants");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var ProgressBar = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(ProgressBar, _Kesi2BasicComponent);

  var _super = _createSuper(ProgressBar);

  function ProgressBar(props, context) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, ProgressBar);
    _this = _super.call(this, props, context, props.id);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getGroupHeight", function (groups, groupKey) {
      var tileHeight = _DrupalNestedTileSizes.TILE_SIZES.LARGE * _this.props.zoomValue;
      var firstAndLastPadding = 2 * _DrupalNestedTileSizes.MARGIN_BETWEEN_TILES * _this.props.zoomValue;
      var otherPadding = 3;

      if (_this.props.openTileGroup === groupKey) {
        return Math.floor(2 * firstAndLastPadding + (groups[groupKey].length - 1) * 2 * otherPadding + groups[groupKey].length * tileHeight + 30);
      } else {
        return Math.floor(2 * firstAndLastPadding + tileHeight / 2 + 30);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getProgressBubbleTop", function (groups, content, index) {
      var groupKey = content.keyword;
      var tileHeight = _DrupalNestedTileSizes.TILE_SIZES.LARGE * _this.props.zoomValue;
      var firstAndLastPadding = 2 * _DrupalNestedTileSizes.MARGIN_BETWEEN_TILES * _this.props.zoomValue;
      var otherPadding = 3;
      var bubblePosition = tileHeight / 2;
      var groupIndex = (0, _keys["default"])(groups).indexOf(content.keyword);
      var prevGroupHeight = 0;

      for (var i = 0; i < groupIndex; i++) {
        var _groupKey = (0, _keys["default"])(groups)[i]; // add 30 px for the dateheader of every group

        prevGroupHeight += _this.getGroupHeight(groups, _groupKey);
      }

      if (groupKey === _this.props.openTileGroup) {
        return "".concat(bubblePosition + (2 * firstAndLastPadding + (groups[content.keyword].length - 1) * 2 * otherPadding) + index * tileHeight + prevGroupHeight - 60, "px");
      } else {
        return "".concat(bubblePosition / 2 + 2 * firstAndLastPadding + prevGroupHeight - 60, "px");
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getContentGroups", function () {
      var groups = {};

      _this.props.elements.forEach(function (content) {
        var failingPrecondition = (0, _PreconditionChecker.getFailingPrecondition)(content.showPrecondition);

        if (content && content.keyword && !failingPrecondition) {
          if (groups[content.keyword]) {
            groups[content.keyword].push(content.id);
          } else {
            groups[content.keyword] = [content.id];
          }
        }
      });

      return groups;
    });
    _this.state = {};
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(ProgressBar.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA]);
    return _this;
  }

  (0, _createClass2["default"])(ProgressBar, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var fullGroupHeight = 0;
      var groups = this.getContentGroups();

      if ((0, _keys["default"])(groups).length === 0) {
        return null;
      }

      (0, _keys["default"])(groups).forEach(function (groupKey) {
        fullGroupHeight += _this2.getGroupHeight(groups, groupKey);
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          height: "".concat(fullGroupHeight - 60, "px")
        },
        className: "".concat(_ErvNestedTiles["default"].progressBarContainer)
      }, this.props.elements.filter(function (el) {
        // filter all non visible tiles so they wont affect bubble heights etc
        var failingPrecondition = (0, _PreconditionChecker.getFailingPrecondition)(el.showPrecondition);
        return !failingPrecondition;
      }).map(function (tile, index) {
        var progress;
        var additionalData = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA) || {};
        var failingPrecondition = (0, _PreconditionChecker.getFailingPrecondition)(tile.showPrecondition);

        if (failingPrecondition) {
          return null;
        }

        progress = _KESI2Helper["default"].getPercentageForContent(tile.id);

        var groups = _this2.getContentGroups();

        var groupLength = 0;
        (0, _keys["default"])(groups).forEach(function (groupKey) {
          if (groupKey.indexOf('day') !== -1) {
            groupLength++;
          }
        });
        var ownGroup = groups[tile.keyword];
        var indexInGroup = ownGroup.indexOf(tile.id);

        var top = _this2.getProgressBubbleTop(groups, tile, indexInGroup); // nur ein Böppel pro Gruppe


        return /*#__PURE__*/_react["default"].createElement("div", {
          className: _ErvNestedTiles["default"].progressBubbleContainer,
          style: {
            top: top,
            left: '5px'
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "".concat(_ErvNestedTiles["default"].progressBubble, " ").concat(progress === 100 ? _ErvNestedTiles["default"].done : '')
        }, progress === 100 ? /*#__PURE__*/_react["default"].createElement(_Check["default"], {
          className: _ErvNestedTiles["default"].progressDone
        }) : progress > 0 ? /*#__PURE__*/_react["default"].createElement("div", {
          className: _ErvNestedTiles["default"].progressStarted
        }) : null));
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _ErvNestedTiles["default"].progressBar,
        style: {
          height: '100%'
        }
      }));
    }
  }]);
  return ProgressBar;
}(_KESI2BasicComponent["default"]);

ProgressBar.propTypes = {
  elements: _propTypes["default"].array,
  zoomValue: _propTypes["default"].number,
  openTileGroup: _propTypes["default"].string
};
ProgressBar.defaultProps = {};
var _default = ProgressBar;
exports["default"] = _default;